import { LockOutlined } from '@mui/icons-material';
import { Button, Typography, Box } from '@mui/material';
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div style={{ padding: 32, textAlign: 'center', maxWidth: 800, margin: '0 auto' }}>
            <LockOutlined style={{ fontSize: 60, color: '#757575', marginBottom: 16 }} />
            <Typography variant="h4" gutterBottom>
                Access Denied
            </Typography>
            <Typography variant="body1" sx={{ fontSize: 18, lineHeight: 1.6, marginBottom: 3 }}>
                We can't open this chart layout for you.<br /><br />
                If you wish to see someone else's chart layout, then please ask the owner to enable chart layout sharing.
            </Typography>

            <Box mt={4} display="flex" justifyContent="center">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleGoHome}
                >
                    Go to Homepage
                </Button>
            </Box>
        </div>
    );
};

export default AccessDenied;
